module.exports = __webpack_public_path__ + "static/media/16-mercedes.29f19124.jpg";